/*
 * Copyright (c) 2025 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, April 17th 2025, 9:30:02 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

/*
 * Copyright (c) 2023 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, May 11th 2023, 5:00:39 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { TaskTemplate } from "lib/schemas";
import { AIAgentConfigurationManyToOnePicker } from "ai-workers/components";

interface AITaskFieldsProps {
  aiAgentConfigurationId: TaskTemplate["ai_task_instruction"];
}

export const AITaskSettings = ({ aiAgentConfigurationId }: AITaskFieldsProps) => {
  return (
    <AIAgentConfigurationManyToOnePicker<TaskTemplate>
      schema_field_key="ai_task_instruction"
      label="AI Task Instruction"
    />
  );
};
